export default "__VITE_ASSET__16440c10__"